// extracted by mini-css-extract-plugin
module.exports = {"dragzone":"image_upload_field__dragzone___2nzOY","dragover":"image_upload_field__dragover___YKSei","not-supported":"image_upload_field__not-supported___34Kr9"};